import { render } from "./CreateTemplatePanel.vue?vue&type=template&id=606408d5&scoped=true"
import script from "./CreateTemplatePanel.vue?vue&type=script&lang=js"
export * from "./CreateTemplatePanel.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/whisk/whisk/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-606408d5"]])

export default __exports__